export const products = [
    {
        id: '1',
        name: '安防产品',
        productArr: [
            {
                productArrId: '1',
                productArrName: '监控拼接屏',
                src: require("@/assets/img/jiankong.png")
            },
            {
                productArrId: '2',
                productArrName: '监控NVR',
                src:require('@/assets/img/jiangkongNVR.png')
            },
            {
                productArrId: '3',
                productArrName: '环境监测',
                src:require('@/assets/img/environmental.png')
            },
            {
                productArrId: '4',
                productArrName: '通道闸',
                src:require('@/assets/img/passage.png')
            },
            {
                productArrId: '5',
                productArrName: '停车场系统',
                src:require('@/assets/img/parklat.png')
            },
            {
                productArrId: '6',
                productArrName: '报警产品',
                src:require('@/assets/img/baojing.png')
            },
            {
                productArrId: '7',
                productArrName: '防撞桩',
                src:require('@/assets/img/fangzhuang.png')
            },
            {
                productArrId: '8',
                productArrName: '摄像机',
                src:require('@/assets/img/vidicon.png')
            },
            {
                productArrId: '9',
                productArrName: '太阳能监控',
                src:require('@/assets/img/solarMonitoring.png')
            },
        ]
    },
    {
        id: '2',
        name: '快递分拣产品',
        productArr: [
            {
                productArrId: '1',
                productArrName: '快递分拣系统',
                src:require('@/assets/img/expressSorting.png')
            },
            {
                productArrId: '2',
                productArrName: '快递县级共配分拣系统',
                src:require('@/assets/img/kuaidi.png')
            },
        ]
    },
    {
        id: '3',
        name: '隧道监控产品',
        productArr: [
            {
                productArrId: '1',
                productArrName: '可变情报板',
                src:require('@/assets/img/messageSign.png')
            },
            {
                productArrId: '2',
                productArrName: '集中监控软件',
                src:require('@/assets/img/centerSoftware.png')
            },
            {
                productArrId: '3',
                productArrName: 'PLC控制箱',
                src:require('@/assets/img/PLCcontrol.png')
            },
            {
                productArrId: '4',
                productArrName: '隧道全息可视化管理系统',
                src:require('@/assets/img/tunnelSystem.png')
            },
        ]
    }
]